import axios from "@/plugins/axios";

let url = "/api/console/nshop/orders";

/** @typedef {import('../../../../store/nshop').NshopOrder} $NshopOrder */

export const orders = {
    /**
     * @param {import("axios").AxiosRequestConfig} data
     * @returns {Promise<{ summary: { totalCount: number }, orders: $NshopOrder[]}>}
     */
    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },

    /**
     * @param {{ _id: string }} data
     * @returns {Promise<{ order: $NshopOrder }>}
     */
    get(data) {
        return axios.get(`${url}/${data._id}`).then((result) => result.data);
    },

    /**
     * @param {Partial<$NshopOrder>} data
     * @returns {Promise<{ order: $NshopOrder }>}
     */
    put(data) {
        return axios.put(`${url}/${data._id}`, data).then((result) => result.data);
    },

    resend: {
        /**
         * @param {{ _id: string }} data
         * @returns {Promise<{ order: $NshopOrder }>}
         */
        post(data) {
            return axios.post(`${url}/${data._id}/resend`, data).then((result) => result.data);
        },
    },

    cancel: {
        /**
         * 결제취소(환불) — 나누리핀 폐기 + 쿠콘 540 취소.
         * @param {{ _id: string }} data
         * @returns {Promise<{ order: $NshopOrder }>}
         */
        post(data) {
            return axios.post(`${url}/${data._id}/cancel`, data).then((result) => result.data);
        },
    },
};

export default orders;
